import { WarrantyType } from "Store/findVehicle/interfaces";
import { formatDateToString } from "Utils/dateUtils";

export const getCarPriceIssueDate = (
  warrantyType: WarrantyType | undefined,
): string | undefined =>
  warrantyType !== WarrantyType.COMPANY_CHANGE
    ? formatDateToString(new Date())
    : undefined;
